<ng-container [formGroup]="form">
    <mat-radio-group
        [formControlName]="question.key"
        appearance="outline"
        class="ca-radio-group"
        [id]="question.key"
        [attr.data-testid]="question.key"
        [ngClass]="question.styles"
    >
        <mat-radio-button
            [disableRipple]="true"
            *ngFor="let option of question.options; trackBy: trackByKey"
            [id]="question.key + (option.id || option.value)"
            [attr.data-testid]="question.key + (option.id || option.value)"
            [disabled]="option.disabled"
            [checked]="option.checked"
            [value]="option.value"
            class="inline-block"
            [ngClass]="{
                'ca-radio-with-image': option.img && !(option.icon || option.iconGroup),
                'ca-radio-with-icon': (option.icon || option.iconGroup) && !option.img,
                'ca-radio-disabled': option.disabled || question.disabled
            }"
        >
            <ca-icon *ngIf="!option.img && !option.iconGroup && option.icon" [icon]="option.icon" class="ca-icon-s-24-p-0-f-24"></ca-icon>
            <div *ngIf="!option.img && !option.icon && option.iconGroup" class="ca-radio-icon-group">
                <ca-icon *ngFor="let icon of option.iconGroup" [icon]="icon" class="ca-icon-s-24-p-0-f-24"></ca-icon>
            </div>
            <img *ngIf="!option.icon && option.img" [src]="option.img" [alt]="option.key" class="mb-2" />
            <span class="ca-truncate-text">{{ option.key | translate }}</span>
            <span *ngIf="option.subtext && !option.img" class="block radio-subtext">{{ option.subtext | translate }}</span>
        </mat-radio-button>
    </mat-radio-group>
    <div *ngIf="question.validators?.length" class="vp-subscript relative mt-2">
        <div class="absolute vp-error-message" *ngIf="isInvalid && errorMessage" @slideDown>
            <ca-form-error-message [attr.data-testid]="question.key + '-error-message'">
                {{ errorMessage | translate }}
            </ca-form-error-message>
        </div>
    </div>
</ng-container>
